/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-10-08 16:26:00
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-17 10:18:15
 */
const getters = {
  userInfo: state => state.user.userInfo,
  loginCard:state => state.user.loginCard,
  messageList:state => state.im.messageList,
  startChat:state => state.im.startChat,
  startChatTime:state => state.im.startChatTime,
  stopChat:state => state.im.stopChat,
  harvestAddress:state => state.address.harvestAddress,
  orderType:state => state.address.orderType,
  goodsOrderList:state => state.aggPack.goodsOrderList,
  agreement:state => state.user.agreement,
  showAgreement:state => state.user.showAgreement,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js